export default __webpack_public_path__ + "static/media/proBus.a215414d.png";